import { useQuery } from '@tanstack/react-query';
import { getBuilderWhatsapp } from '../services/api/implementation/impl';
import {
  BUILDER_WHATSAPP_QUERY_KEY,
  isBuilderWhatsappConfigured
} from '../utils/builderWhatsappAccess';

/**
 * Builder WhatsApp API integration status (same rules as Integration page).
 * `allowWhatsAppCampaignsSidebar` is true only after a successful response with credentials set.
 */
export function useBuilderWhatsappIntegration() {
  const query = useQuery({
    queryKey: BUILDER_WHATSAPP_QUERY_KEY,
    queryFn: getBuilderWhatsapp,
    retry: false
  });

  const configured =
    !query.isError && isBuilderWhatsappConfigured(query.data);

  const allowWhatsAppCampaignsSidebar = !query.isPending && configured;

  return {
    ...query,
    configured,
    allowWhatsAppCampaignsSidebar
  };
}
